import React, { useState, useEffect, useRef } from 'react'
import _ from 'lodash'

export default function PlayerRow(props) {
  const { game, pr } = props
  const [editCost, setEditCost] = useState(false)
  const [editName, setEditName] = useState(false)
  const [showPaidMenu, setShowPaidMenu] = useState(false)
  const menuRef = useRef()
  const menuButtonRef = useRef()
  const costInputRef = useRef(null)
  const nameInputRef = useRef(null)
  const paid_amount = parseFloat(pr.paid_amount)
  const cost_of_player = parseFloat(pr.cost_of_player)
  const isFullyPaid = pr.fully_paid

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (showPaidMenu && menuRef.current && !menuRef.current.contains(e.target) && !menuButtonRef.current.contains(e.target)) {
        setShowPaidMenu(false)
      }
    }
    document.addEventListener('mousedown', checkIfClickedOutside)
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside)
    }
  }, [showPaidMenu])

  const onClickName = () => {
    if (pr.player_id) props.onShowPlayer(pr.player_id)
    else setEditName(true)
  }

  const renamePlayer = (e) => {
    e.preventDefault()
    const name = nameInputRef.current.value
    if (name) props.onRenamePlayer({ id: pr.id, name: name })
  }

  const changeCost = () => {
    const cost = costInputRef.current.value
    if (cost < 0 || cost > 1000000) return

    if (cost_of_player != cost) props.onEditCost({ id: pr.id, cost: cost })
    setEditCost(false)
  }

  const refundPayment = () => {
    pr.paid_for ? props.onRefundPaidFor(pr.refund_id) : props.onRefund(pr.refund_id) 
  }

  const changeReservation = () => {
    props.onChangeReservation(pr.id)
  }

  const paidMenu = () => {
    return <div className='player-reservation-paid-modal' ref={menuRef}>
      <span></span>
      <div className='reservation-paid__option change_reservation' onClick={changeReservation}>
        Change Reservation
      </div>
      { pr.receipt_id &&
        <div className='reservation-paid__option view_receipt' onClick={() => props.onShowReceipt(pr.receipt_id)}>
          View Receipt
        </div>
      }
      <div className='reservation-paid__option refund_transaction' onClick={refundPayment}>
        Refund
      </div>
    </div>
  }

  return <tr className='player'>
    <td className='col-xs-6 text-left player-edit-name-wrapper'>
      <h5>
        <a className='clickable' onClick={onClickName}>{pr.displayed_name}</a>
        { editName && 
          <form>
            <input 
              autoFocus
              type='text'
              className='form-control'
              placeholder='Player Name'
              ref={nameInputRef}
              onBlur={() => setTimeout(() => { setEditName(false) }, 300)}
            />
            <input 
              className='btn btn-info'
              type='submit'
              name='commit'
              value='OK'
              onClick={(e) => renamePlayer(e) }
            />
          </form>
        }
      </h5>
    </td>

    <td className='col-xs-2'>
      { !editCost &&
        <h5>
          <span className='cost'>$&nbsp;{cost_of_player.toFixed(2)}</span>&nbsp;
          {(pr.paid_amount == 0 || !isFullyPaid) && <span className='toggle-cost-edit fa fa-pencil' onClick={() => setEditCost(true)}></span>}
        </h5>
      }
      { editCost &&
        <form className='edit_player_reservation'>
          <div className='dollar-field inline'>
            <input step='0.01' className='form-control' type='number' 
              autoFocus ref={costInputRef} onBlur={() => setTimeout(() => { setEditCost(false) }, 300)} />
          </div>
          <input type='submit' name='commit' value='OK' className='btn btn-info' 
            onClick={(e) => { e.preventDefault(); changeCost() }} />
        </form>
      }
    </td>

    { isFullyPaid &&
      <td className='col-xs-1 actions player-reservation-paid-button'>
        <button className='btn btn-success' type='button' ref={menuButtonRef} onClick={(e) => setShowPaidMenu(true)}>
          {pr.payment_label}
        </button>
        { showPaidMenu && paidMenu() }
      </td>
    }
    { !isFullyPaid &&
      <td className='col-xs-1 actions'>
        <a className='btn btn-info clickable' onClick={() => props.onPayment(pr.id)}>Pay</a>
      </td>
    }
    <td className='col-xs-1'>
      { !(pr.is_game_master || (paid_amount > 0 && !pr.paid_for)) && 
        <a className='btn btn-danger' onClick={() => props.onDeletePlayer(pr.id)}><i className='fa fa-trash-o'></i></a>
      }
    </td>
  </tr>
}
